import { FC } from 'react';
import { Box, Divider, Text } from '@hopskipdrive/react-components';

import { FareBreakdownContainer } from './styles';

interface PerTripFareOverviewProps {
  isFetching: boolean;
  rideInfo: {
    estimatedFare?: string;
    totalFareWithCredits?: string;
    rideCredits?: {
      amount: number;
      display: string;
      kind: string;
      label: string;
    }[];
  };
}

export const PerTripFareOverview: FC<PerTripFareOverviewProps> = ({ rideInfo }) => {
  const { rideCredits, estimatedFare, totalFareWithCredits } = rideInfo;

  return (
    <Box display="flex">
      <FareBreakdownContainer>
        {
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text variant="labelXS" textColor="secondaryText">
              {rideCredits && rideCredits.length !== 0 ? 'Fare subtotal' : 'Fare total'}
            </Text>
            <Text variant="labelL" textColor="secondary-hover">
              {estimatedFare}
            </Text>
          </Box>
        }
        {rideCredits &&
          rideCredits?.map((credits, index) => (
            <Box display="flex" key={index} alignItems="center" justifyContent="space-between">
              <Text variant="labelXS" textColor="secondaryText">
                {credits.label}
              </Text>
              <Text variant="labelL" textColor="success">
                {credits.display}
              </Text>
            </Box>
          ))}
        {rideCredits && rideCredits.length > 0 && (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text variant="labelXS" textColor="secondaryText">
              Fare total
            </Text>
            <Box>
              <Divider sx={{ mt: '3px', mb: '3px' }} />
              <Text textColor="info-main" style={{ fontSize: '20px' }}>
                {totalFareWithCredits}
              </Text>
            </Box>
          </Box>
        )}
      </FareBreakdownContainer>
    </Box>
  );
};
